import { render, staticRenderFns } from "./RedirectReturnNotice.vue?vue&type=template&id=1e182ada&scoped=true"
import script from "./RedirectReturnNotice.vue?vue&type=script&lang=js"
export * from "./RedirectReturnNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e182ada",
  null
  
)

export default component.exports